var _circle, _circle2, _path, _path2, _circle3, _circle4, _rect, _path3, _path4, _ellipse, _rect2, _rect3, _rect4, _polygon, _polygon2, _rect5, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _polygon3, _ellipse2, _ellipse3, _path15, _path16, _path17, _path18, _circle5, _polygon4, _rect6, _path19, _path20, _circle6, _circle7, _path21, _path22, _path23, _polygon5, _polygon6, _polygon7, _polygon8, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfessionalIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fb414a8b-d0ff-4841-818a-532ec941ba8d",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 583.9043,
    height: 652,
    viewBox: "0 0 583.9043 652",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "modern professional") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 137.03198,
    cy: 553.16387,
    r: 14.92017,
    fill: "#6415ff",
    opacity: 0.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.41853,
    cy: 560.28992,
    r: 10.46639,
    fill: "#6415ff",
    opacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M839.05005,473.26123A255.4403,255.4403,0,0,0,821.148,248.49384L413.04785,305l391.09027-81.50568A254.56224,254.56224,0,0,0,602.04785,124c-140.83264,0-255,114.16736-255,255a257.18949,257.18949,0,0,0,2.37335,34.7973Z",
    transform: "translate(-308.04785 -124)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M364.09235,470.8103C400.95038,566.27441,493.58374,634,602.04785,634c101.778,0,189.61694-59.63409,230.51453-145.86108Z",
    transform: "translate(-308.04785 -124)",
    fill: "#f2f2f2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 112,
    r: 12,
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 538,
    cy: 252,
    r: 12,
    fill: "#6415ff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 339,
    width: 20,
    height: 20,
    fill: "#6415ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M576.04785,317s33-14.37945,48.5.81027S583.04785,328,576.04785,317Z",
    transform: "translate(-308.04785 -124)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M633.03015,248.80469c-11.08984-18.73841-33.03021-19.6117-33.03021-19.6117s-21.37964-2.734-35.09454,25.80481c-12.78339,26.60053-30.42609,52.28388-2.84034,58.51087L567.04785,298l3.08582,16.66327a107.93429,107.93429,0,0,0,11.80291.20172c29.54212-.9538,57.67652.27905,56.77063-10.3219C637.503,290.45062,643.70081,266.83478,633.03015,248.80469Z",
    transform: "translate(-308.04785 -124)",
    fill: "#2f2e41"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 294.5,
    cy: 398,
    rx: 56,
    ry: 13,
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 593.47388,
    y: 683.50021,
    width: 54.14795,
    height: 1.99959,
    transform: "translate(-356.83712 -76.37339) rotate(-4.22916)",
    fill: "#2f2e41"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 566.54805,
    y: 669.58729,
    width: 1.99959,
    height: 22.82542,
    transform: "translate(-610.71498 726.10779) rotate(-61.18921)",
    fill: "#2f2e41"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 288.5,
    y: 543.5,
    width: 18,
    height: 2,
    fill: "#2f2e41"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "241.498 650.568 239.502 650.432 254.502 418.432 256.498 418.568 241.498 650.568",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "315.501 650.549 305.501 422.549 307.499 422.451 317.499 650.451 315.501 650.549",
    fill: "#2f2e41"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 651.04766,
    y: 544.10828,
    width: 2.00039,
    height: 230.78345,
    transform: "translate(-360.12854 -68.08069) rotate(-4.72229)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M648.54785,588.5s-14,26-23,26-8,17-6,21,7,13-1,26c-2.7944,4.54089-2.29452,9.69184-.4608,14.47262,5.13784,13.3951,25.12393,9.33685,24.48633-4.99562q-.01054-.237-.02553-.477c-1-16,7-41,15-47s15-22,15-22Z",
    transform: "translate(-308.04785 -124)",
    fill: "#ffb8b8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M552.54785,582.5s14,26,23,26,8,17,6,21-7,13,1,26c2.7944,4.54089,2.29452,9.69184.4608,14.47262-5.13784,13.3951-25.12392,9.33685-24.48633-4.99562q.01054-.237.02553-.477c1-16-7-41-15-47s-15-22-15-22Z",
    transform: "translate(-308.04785 -124)",
    fill: "#ffb8b8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M563.54785,454.5l-6,13s-88,29-80,63,47,87,53,85,38-8,39-25-23-47-23-47l33-30,48.02035-1,40.97965,31s-43,38-24,53,47,25,51,19,49-95,42-103-78-38-78-38l-19-27-74-4Z",
    transform: "translate(-308.04785 -124)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M581.54785,289.5s5,33-5,37,20,21,20,21h17l11-23s-10-18-4-35S581.54785,289.5,581.54785,289.5Z",
    transform: "translate(-308.04785 -124)",
    fill: "#ffb8b8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M581.54785,289.5s5,33-5,37,20,21,20,21h17l11-23s-10-18-4-35S581.54785,289.5,581.54785,289.5Z",
    transform: "translate(-308.04785 -124)",
    opacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M574.54785,317.5s11,12,13,14,11,13,30-3,21,3,21,3v120s-16-7-29,0-40-2-40-2l-5-124Z",
    transform: "translate(-308.04785 -124)",
    fill: "#d0cde1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M581.89324,317.5s-9.34539-4-17.34539,0-36,24-34,33,28,72,10,102-21,38-21,38l44-23s34-21,31-34S581.89324,317.5,581.89324,317.5Z",
    transform: "translate(-308.04785 -124)",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M621.55965,317.5s20.9882,2,21.9882,4,31.5,10.5,29.5,19.5-29.5,89.5-17.5,104.5,32,36,25,38-19-3-31,0-40-22-37-49S612.57144,324.5,621.55965,317.5Z",
    transform: "translate(-308.04785 -124)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M571.54785,508.5v10s-5,23,11,22,6-28,6-28l-1-9Z",
    transform: "translate(-308.04785 -124)",
    fill: "#ffb8b8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M616.54785,509.5s-11,23,0,25,19-13,19-17S616.54785,509.5,616.54785,509.5Z",
    transform: "translate(-308.04785 -124)",
    fill: "#ffb8b8"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "272.5 650.524 270.5 650.476 276.5 420.476 278.5 420.524 272.5 650.524",
    fill: "#2f2e41"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 323,
    cy: 152,
    rx: 2,
    ry: 4,
    fill: "#ffb8b8"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 264,
    cy: 152,
    rx: 2,
    ry: 4,
    fill: "#ffb8b8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M648.54785,330.5s25,0,24,10-34,182-34,182-14-13-26-10Z",
    transform: "translate(-308.04785 -124)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M551.54785,333.5s-25,5-25,20,36,159,41,159,24-3,24-8S551.54785,333.5,551.54785,333.5Z",
    transform: "translate(-308.04785 -124)",
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M557.04785,363l22.5,87.991S569.04785,374,557.04785,363Z",
    transform: "translate(-308.04785 -124)",
    opacity: 0.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M644.56486,350.63621,621.809,465.6798S629.08188,357.27242,644.56486,350.63621Z",
    transform: "translate(-308.04785 -124)",
    opacity: 0.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 293.5,
    cy: 152.5,
    r: 29,
    fill: "#ffb8b8"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "320.079 122.998 298.403 111.644 268.47 116.289 262.277 143.642 277.693 143.049 282 133 282 142.884 289.114 142.61 293.242 126.611 295.823 143.642 321.112 143.126 320.079 122.998",
    fill: "#2f2e41"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 650,
    width: 546,
    height: 2,
    fill: "#2f2e41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M772.63086,774.01953l-2-.03906a463.83471,463.83471,0,0,1,7.09961-66.28711c8.64844-46.88086,23.0293-77.66992,42.74316-91.51172l1.14844,1.63672C775.57031,650.15234,772.6543,772.78418,772.63086,774.01953Z",
    transform: "translate(-308.04785 -124)",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M797.63086,773.541l-2-.03907c.043-2.21484,1.293-54.41406,21.84277-68.84179l1.14844,1.63672C798.90137,720.14258,797.64063,773.00879,797.63086,773.541Z",
    transform: "translate(-308.04785 -124)",
    fill: "#2f2e41"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 525,
    cy: 483,
    r: 10,
    fill: "#6415ff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 520,
    cy: 570,
    r: 10,
    fill: "#6415ff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M792.96963,623.99461c1.87935,12.004-3.01891,22.74063-3.01891,22.74063s-7.94529-8.72581-9.82464-20.72985,3.0189-22.74063,3.0189-22.74063S791.09027,611.99057,792.96963,623.99461Z",
    transform: "translate(-308.04785 -124)",
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M825.6568,653.14836c-11.49295,3.9422-22.91878.98962-22.91878.98962s7.20793-9.34414,18.70088-13.28634,22.91879-.98962,22.91879-.98962S837.14975,649.20616,825.6568,653.14836Z",
    transform: "translate(-308.04785 -124)",
    fill: "#2f2e41"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M826.02605,729.3095a31.134,31.134,0,0,1-16.06421.69365,28.37377,28.37377,0,0,1,29.172-10.0063A31.134,31.134,0,0,1,826.02605,729.3095Z",
    transform: "translate(-308.04785 -124)",
    fill: "#2f2e41"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "2 192 0 192 0 62 128 62 128 64 2 64 2 192",
    fill: "#2f2e41"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "583.904 192 581.904 192 581.904 64 455.904 64 455.904 62 583.904 62 583.904 192",
    fill: "#2f2e41"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "2 302 0 302 0 432 128 432 128 430 2 430 2 302",
    fill: "#2f2e41"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "583.904 302 581.904 302 581.904 430 455.904 430 455.904 432 583.904 432 583.904 302",
    fill: "#2f2e41"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 123,
    width: 140,
    height: 2,
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 105,
    width: 2,
    height: 18.5,
    fill: "#3f3d56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 105,
    width: 2,
    height: 18.5,
    fill: "#3f3d56"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 414,
    y: 264,
    width: 140,
    height: 2,
    fill: "#3f3d56"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 452,
    y: 246,
    width: 2,
    height: 18.5,
    fill: "#3f3d56"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 513,
    y: 246,
    width: 2,
    height: 18.5,
    fill: "#3f3d56"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 358,
    width: 140,
    height: 2,
    fill: "#3f3d56"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 340,
    width: 2,
    height: 18.5,
    fill: "#3f3d56"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 340,
    width: 2,
    height: 18.5,
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessionalIllustration);
export default __webpack_public_path__ + "static/media/professional-illustration.9453105dfa6d138fd1e68a1b86235663.svg";
export { ForwardRef as ReactComponent };